import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { STATUS_VARIANT_HIGHLIGHT, StatusType } from '@/components/StatusWrapper/const';
import { ValueOf } from '@/types/sharedTypes';

export const SINGLE_PAYMENT_INVOICE_STATUS = {
  PAID: 'paid',
  FAILED: 'failed',
} as const;

export type SinglePaymentInvoiceStatusType = ValueOf<typeof SINGLE_PAYMENT_INVOICE_STATUS>;

type SinglePaymentInvoiceStatusPropsType = {
  status: SinglePaymentInvoiceStatusType;
};

export const SINGLE_PAYMENT_INVOICE_STATUS_MAP: StatusType = {
  [SINGLE_PAYMENT_INVOICE_STATUS.PAID]: { title: 'Paid', variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [SINGLE_PAYMENT_INVOICE_STATUS.FAILED]: { title: 'Failed', variant: STATUS_VARIANT_HIGHLIGHT.RED },
};

export const SinglePaymentInvoiceStatus = ({ status }: SinglePaymentInvoiceStatusPropsType) => {
  const statusMap = SINGLE_PAYMENT_INVOICE_STATUS_MAP[status];

  return <StatusWrapper variant={statusMap?.variant}>{statusMap?.title}</StatusWrapper>;
};
